import { render, staticRenderFns } from "./OrderPriceSummary.vue?vue&type=template&id=4c7e4f7a&scoped=true&lang=pug"
import script from "./OrderPriceSummary.vue?vue&type=script&lang=js"
export * from "./OrderPriceSummary.vue?vue&type=script&lang=js"
import style0 from "./OrderPriceSummary.vue?vue&type=style&index=0&id=4c7e4f7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c7e4f7a",
  null
  
)

export default component.exports